import React, { createContext, useContext, useMemo } from 'react';
import { useHybridAuth } from '../HybridAuthProvider';
import { createSecurityWorker } from './workers';
import { Api, HttpClient } from './Api';

const ApiClientContext = createContext<Api<any> | null>(null);

export const ApiClientProvider: React.FC<{ children: React.ReactNode }> = ({ children }) => {
  const { getAccessToken, login } = useHybridAuth();
  const httpClient = new HttpClient({
    baseApiParams: { secure: true, format: 'json' },
    securityWorker: async () => {
      const token = await getAccessToken().catch((err) => {
        console.error('Token fetch failed:', err);
        login();
      });
      return token ? { headers: { Authorization: `Bearer ${token}` } } : {};
    },
    baseUrl: process.env.REACT_APP_API_URL,
  });

  const apiClient = new Api(httpClient);

  return <ApiClientContext.Provider value={apiClient}>{children}</ApiClientContext.Provider>;
};

export const useApiClient = () => {
  const ctx = useContext(ApiClientContext);
  if (!ctx) throw new Error('useApiClient must be used within ApiClientProvider');
  return ctx;
};
